export const LABEL = 'LABEL';
export const DATE = 'DATE';
export const RADIO = 'RADIO';
export const MULTIRADIO = 'MULTIRADIO';
export const TEXT = 'TEXT';
export const MVPOP = 'MVPOP';



// WEBPACK FOOTER //
// ./src/scripts/constants/property-type-constants.js